import get from 'lodash.get';

const getThemes = (state) => get(state, 'ws.template.meta.customization.themes', []);

export default getThemes;
